import React from 'react';
import {
  useAllInOneContext,
  useTargetListAddContext,
  useTargetListEditContext,
  useActiveListContext,
} from '../../../context';
import { Float } from '../../float';
import { Scroll } from '../../core';
import { CardBack, ListChoiceButton } from './styles';
import { COLORS, COLORS_L2 } from '../../../constants';
import { FaCheck } from 'react-icons/fa';
import './styles/styles.scss';

export const ListChoices = ({
  setShowLists,

  option = 'Add',
}) => {
  const { lists } = useAllInOneContext();
  const { targetList, setTargetList } =
    option == 'Add' ? useTargetListAddContext() : useTargetListEditContext();
  const { themeColor, themeColor_L2 } = useActiveListContext();

  return (
    lists && (
      <Float.SubCard>
        <CardBack
          color={themeColor}
          color_L2={themeColor_L2}
          onClick={() => {
            setShowLists(false);
          }}
        >
          Back
        </CardBack>
        <Scroll className='ListChoiceScroll'>
          {lists.map((list) => (
            <ListChoiceButton
              color={COLORS[list.color]}
              color_L2={COLORS_L2[list.color]}
              theme={themeColor}
              key={list.docID}
              onClick={() => setTargetList(list.docID)}
            >
              <span>
                <div></div>
                <span>{list.name}</span>
              </span>
              <div
                style={{
                  visibility: targetList == list.docID ? 'visible' : 'hidden',
                }}
              >
                <FaCheck />
              </div>
            </ListChoiceButton>
          ))}
        </Scroll>
      </Float.SubCard>
    )
  );
};
